import React from "react"
import DodonesList from 'app/dodones/list/Index'
import DodoneStartButton from 'app/dodones/shared/StartButton'
import DodoneFinishButton from 'app/dodones/shared/FinishButton'
import DodoneNextLink from 'app/dodones/shared/NextLink'
import DodoneCommentFieldTrigger from 'app/dodones/fields/comment/Trigger'
import { useContext, useEffect, useState, useCallback } from "react"
import DodoneChronometer from 'app/dodones/shared/Chronometer'
import DodoneGenericStats from 'app/dodones/generic/Stats'
import update from "immutability-helper"
import DodonesFields from 'app/dodones/shared/Fields'

import DodoneContext from 'app/dodones/Context'
import HeaderContext from 'app/HeaderContext'

const StartedGeneric = () => {
  const { dodone, onTick, updateDodone } = useContext(DodoneContext)
  const [attributes, setAttributes] = useState({})

  const onAttributeChanged = useCallback((e) => {
    const nextAttributes = update(attributes, {
      [e.target.name]: { $set: e.target.value }
    })

    setAttributes(nextAttributes)
  }, [attributes])

  return <>
           {
             dodone.isFinished ?
               <div className="fcol mb-d">
                 <DodoneGenericStats dodone = { dodone } />
               </div> :
             <>
               <div className="mb-d">
                 <DodoneChronometer dodone={ dodone } onTick={ onTick } />
               </div>
               <div className="mb-d">
                 <DodoneCommentFieldTrigger dodone={ dodone } />
               </div>
             </>
           }
           <DodonesFields dodone={ dodone } updateDodone={ updateDodone } />
           <DodonesList dodones={ dodone.children } />
           {
             dodone.isFinished ?
               <DodoneNextLink currentDodoneId = { dodone.id } /> :
             <DodoneFinishButton attributes = { attributes } />
           }
         </>
}

const FinishedGeneric = () => {
  const { dodone } = useContext(DodoneContext);

  return <div className="fcol flex-1">
           <DodonesList dodones={ dodone.children } />
         </div>
}

export default () => {
  const { dodone } = useContext(DodoneContext);
  const { setText } = useContext(HeaderContext);

  useEffect(() => {
    setText(dodone.dodoable.name)
  }, [dodone.id])

  if(dodone.isStarted)
    return <StartedGeneric  />

  return <>
           <div className="flex-1 fcol">
             <DodonesFields dodone={ dodone } />
             <DodonesList dodones={ dodone.children } />
           </div>
           <DodoneStartButton text="Start" />
           { dodone.isIgnored && <DodoneNextLink currentDodoneId = { dodone.id } /> }
         </>
}
